<template>
  <v-container>
    <v-dialog v-model="dialog.filter" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-filter</v-icon>
          Filter Laporan
          <v-btn
            class="mt-n1"
            icon
            dark
            top
            right
            absolute
            @click.stop="dialog.filter = false"
          >
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="formFilter">
            <p class="subtitle-2 mb-3 text--secondary">
              Informasi pengguna
            </p>
            <v-text-field
              dense
              outlined
              clearable
              label="NRP/NIK"
              color="light-green"
              v-model="formFilter.account_code"
            />
            <p class="subtitle-2 mb-3 text--secondary">
              Lokasi pengguna
            </p>
            <v-autocomplete
              v-model="formFilter.unit"
              :loading="loadUnitOptions"
              :items="unitOptions"
              :search-input.sync="searchUnitsOptions"
              cache-items
              clearable
              dense
              outlined
              color="light-green"
              label="Wilayah"
              item-text="unitName"
              return-object
            />
            <p class="subtitle-2 mb-3 text--secondary">
              Range tanggal laporan
            </p>
            <v-menu
              ref="start"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.start"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Mulai"
                  clearable
                  @click:clear="formFilter.start = ''"
                  v-model="formFilter.start"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.start"
                @input="picker.start = false"
              >
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="end"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.end"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Selesai"
                  clearable
                  @click:clear="formFilter.end = ''"
                  v-model="formFilter.end"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.end"
                @input="picker.end = false"
              >
              </v-date-picker>
            </v-menu>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click.stop="dialog.filter = false"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="orange lighten-1"
            elevation="0"
            @click="resetFilter"
            class="white--text text-capitalize"
          >
            Reset
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click="saveFilter"
            class="white--text text-capitalize"
          >
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-sheet
              width="100%"
              class="d-sm-flex align-center justify-space-between"
            >
              <div class="text--secondary">List Laporan</div>
              <v-sheet class="d-sm-flex mt-4 mt-sm-0 align-center">
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Cari Laporan . . ."
                  clearable
                  color="light-green"
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4 mb-sm-0 mr-sm-2"
                  :full-width="$vuetify.breakpoint.name === 'xs'"
                >
                </v-text-field>
                <v-row dense class="py-0">
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      @click.stop="
                        dialog.filter = true;
                        formUnitOptionsName = 'filter';
                      "
                    >
                      Filter
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      :loading="loadExportReport"
                      @click="exportReport"
                    >
                      Export
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-sheet>
          </v-card-title>
          <v-card-subtitle v-if="filter.filtered">
            <v-container class="pa-0">
              <v-row dense>
                <v-col cols="12" class="mt-2">
                  Filter By
                </v-col>
                <v-col class="py-0">
                  <v-chip-group show-arrows>
                    <v-chip
                      v-if="filter.start && filter.end"
                      close
                      @click:close="
                        formFilter.start = null;
                        formFilter.end = null;
                        saveFilter();
                      "
                    >
                      Tanggal {{ filter.start }} ~ {{ filter.end }}
                    </v-chip>
                    <v-chip
                      v-if="filter.account_code"
                      close
                      @click:close="
                        formFilter.account_code = '';
                        saveFilter();
                      "
                    >
                      NRP/NIK {{ filter.account_code }}
                    </v-chip>
                    <v-chip
                      v-if="filter.unit"
                      close
                      @click:close="
                        formFilter.unit = null;
                        saveFilter();
                      "
                    >
                      Wilayah {{ filter.unit.unitName }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col
            v-for="(report, i) in loadingReports && page === 1
              ? 8
              : reportsData"
            :key="`report-${i}`"
            cols="12"
            sm="4"
            lg="3"
          >
            <v-skeleton-loader
              width="100%"
              :loading="loadingReports"
              transition="scale-transition"
              type="card"
            >
              <v-card outlined>
                <router-link
                  :to="{
                    name: 'report-detail',
                    params: { id: report.reportId }
                  }"
                >
                  <v-img height="200" :src="report.coverImage" />
                </router-link>
                <v-card-title>
                  <router-link
                    :to="{
                      name: 'report-detail',
                      params: { id: report.reportId }
                    }"
                  >
                    <span
                      class="grey--text text-body-1 font-weight-bold text-md-h6"
                    >
                      {{ report.reportTitle | title }}
                    </span>
                  </router-link>
                </v-card-title>
                <v-card-subtitle>
                  {{ report.reportDatetime | datetime }}
                </v-card-subtitle>
                <v-card-actions>
                  <v-list-item
                    style="max-width:100%"
                    :to="{
                      name: 'user-laporan',
                      params: { id: report.accountId }
                    }"
                    class="grow"
                  >
                    <v-list-item-avatar color="grey darken-2">
                      <v-img
                        class="elevation-6"
                        :alt="report.accountName"
                        :src="report.accountAvatar"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-body-2 grey--text text--darken-2 text-truncate"
                      >
                        {{ report.accountName }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        {{ report.unitName }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-actions>
              </v-card>
            </v-skeleton-loader>
          </v-col>
          <v-col
            v-if="
              paginationReports.totalPage > 1 &&
                page < paginationReports.totalPage
            "
            cols="12"
            class="text-center mt-8 mb-12"
          >
            <v-btn
              :loading="loadingReports"
              color="light-green"
              class="text-capitalize"
              @click="
                page += 1;
                getReportsHandler();
              "
              dark
            >
              Muat lebih banyak
            </v-btn>
          </v-col>
          <v-col cols="12" v-show="!loadingReports && reportsData.length < 1">
            <div class="text-center text--secondary">
              <v-icon
                style="font-size: 60px; margin-top: 1.5em"
                color="light-green"
              >
                mdi-close-circle-outline
              </v-icon>
              <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
              <p>Data yang Anda cari tidak ada disini</p>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import report from '@/mixins/report';
import unit from '@/mixins/unit';
import debounce from 'lodash.debounce';
export default {
  mixins: [report, unit],
  data() {
    return {
      reportsData: [],
      search: '',
      page: 1,
      filter: {
        filtered: false,
        start: null,
        end: null,
        unit: null,
        account_code: ''
      },
      formFilter: {
        start: null,
        end: null,
        unit: null,
        account_code: ''
      },
      picker: {
        start: false,
        end: false
      },
      dialog: {
        filter: false
      }
    };
  },
  watch: {
    search: {
      handler: debounce(function() {
        this.page = 1;
        this.reportsData = [];
        this.getReportsHandler();
      }, 500),
      immediate: true
    }
  },
  methods: {
    async getReportsHandler() {
      const filters = [
        {
          type: 'string',
          field: 'report_title',
          value: this.search,
          comparison: '<>'
        },
        {
          type: 'string',
          field: 'report_account_id',
          value: this.filter.account_code,
          comparison: '<>'
        },
        {
          type: 'string',
          field: 'unit_id',
          value: this.filter.unit && this.filter.unit.unitId
        },
        {
          field: 'report_datetime',
          type: 'date',
          value:
            this.filter.end && this.filter.end.length > 0
              ? `${this.filter.start}::${this.filter.end}`
              : '',
          comparison: 'bet'
        }
      ];
      const payload = {
        filters,
        page: this.page
      };
      const reportsData = await this.getReports(payload);
      this.reportsData.push(...reportsData);
    },
    async saveFilter() {
      this.dialog.filter = false;
      this.reportsData = [];
      this.page = 1;
      this.filter = {
        start: this.formFilter.start,
        end: this.formFilter.end,
        unit: this.formFilter.unit,
        account_code: this.formFilter.account_code
      };
      if (
        (this.formFilter.start && this.formFilter.end) ||
        this.formFilter.account_code ||
        this.formFilter.unit
      ) {
        this.filter.filtered = true;
      }
      await this.getReportsHandler();
    },
    async resetFilter() {
      this.dialog.filter = false;
      this.reportsData = [];
      this.page = 1;
      this.filter = {
        filtered: false,
        start: null,
        end: null,
        unit: null,
        account_code: ''
      };
      this.formFilter = {
        start: null,
        end: null,
        unit: null,
        account_code: ''
      };
      await this.getReportsHandler();
    },
    toDetail(item) {
      this.$router.push({
        name: 'report-detail',
        params: { id: item.reportId }
      });
    }
  }
};
</script>
